import { useLang } from 'hooks/lang';

import { Box, Column, IconButton, LabeledInput, Row } from 'components/Blocks';
import { FileUpIcon, XIcon } from 'components/Icons';
import { FileDropzone } from 'components/Uploads';

import { listGet } from 'utils/array';
import { fileNameToReadable } from 'utils/text';

import { StepComponentProps } from '../types';

export function ProjectFiles({
  files,
  dispatch,
}: Pick<StepComponentProps, 'dispatch'> & {
  files: StepComponentProps['state']['files'];
}) {
  const { t } = useLang();

  const handleFiles = (items: File[]) => {
    dispatch({
      files: (old) => [
        ...old.files,
        ...items
          .filter((f) => !listGet(old.files, f.name, 'name'))
          .map((file) => ({ file, name: fileNameToReadable(file.name) })),
      ],
    });
  };

  const updateName = (name: string, index: number) => {
    dispatch({
      files: (old) => old.files.map((f, i) => (index === i ? { ...f, name } : f)),
    });
  };

  const removeFile = (index: number) => {
    dispatch({
      files: (old) => old.files.filter((_, i) => i !== index),
    });
  };

  return (
    <Column className="mb-2">
      <h6 className="mb-2">{t('files')}</h6>

      {/*
        1. Create a Dropzone component that does NOT handle upload
        2. Change logic to upload files before proj creation
        3. Enable File delete here
        4. Automatically calculate filename but allow changes
      */}
      <FileDropzone onFiles={handleFiles} />

      {files.map(({ file, name }, index) => (
        <Row key={file.name} className="mt-2 px-4 phone:pr-2">
          <Box className="rounded-full bg-primary/20 p-2">
            <FileUpIcon size={20} color="primary-light" />
          </Box>

          <LabeledInput
            value={name}
            onChangeDirect={(name) => updateName(name, index)}
            fullWidth
            error={!name.trim()}
            labelClassName="text-muted-foreground/60 text-xs pl-1"
            label={
              <>
                {file.name}
                <IconButton onClick={() => removeFile(index)}>
                  <XIcon size={12} color="destructive" />
                </IconButton>
              </>
            }
          />
        </Row>
      ))}
    </Column>
  );
}
